import React, { useContext } from 'react';
import { StoreContext } from '../../Store';
import { isLoadStatusSubmitted } from '../../../utils/unifiedLoads';

const SubmitButtons = ({ readOnly, showQATab, handleQASubmitClick, handleLoadSubmitClick, disableSubmit }) => {
  const store = useContext(StoreContext);
  const isLoadSubmitted = isLoadStatusSubmitted(store.loadStatus[0]);

  if (readOnly) return <></>;

  return (
    <div className="d-flex justify-content-between">
      {showQATab ? (
        <button className="blue-button-newload nl-save" onClick={handleQASubmitClick} disabled={disableSubmit}>
          <span>{isLoadSubmitted ? 'Show' : 'Submit'} QA</span>
        </button>
      ) : (
        <button className="blue-button-newload nl-save" onClick={handleLoadSubmitClick} disabled={disableSubmit}>
          <span>Submit Load</span>
        </button>
      )}
    </div>
  );
};

export default SubmitButtons;
